export default "__VITE_ASSET__DZUHlBGn__"